const MAJOR_ARCANA = Array.from({ length: 22 }, (_, rank) => ({ rank }));

const MINOR_RANKS = [
  { key: "ace" },
  { key: "two" },
  { key: "three" },
  { key: "four" },
  { key: "five" },
  { key: "six" },
  { key: "seven" },
  { key: "eight" },
  { key: "nine" },
  { key: "ten" },
  { key: "page" },
  { key: "knight" },
  { key: "queen" },
  { key: "king" },
];

const SUITS = [
  { key: "wands", icon: "🔥" },
  { key: "cups", icon: "💧" },
  { key: "swords", icon: "⚔" },
  { key: "pentacles", icon: "🌿" },
];

function toCardNumber(value) {
  const raw = Number(value);
  if (!Number.isFinite(raw)) return "";
  if (raw === 0) return "0";
  const numerals = [
    [1000, "M"], [900, "CM"], [500, "D"], [400, "CD"], [100, "C"], [90, "XC"],
    [50, "L"], [40, "XL"], [10, "X"], [9, "IX"], [5, "V"], [4, "IV"], [1, "I"],
  ];
  let result = "";
  let remaining = raw;
  numerals.forEach(([n, numeral]) => {
    while (remaining >= n) {
      result += numeral;
      remaining -= n;
    }
  });
  return result;
}

function buildMajorArcanaCards() {
  return MAJOR_ARCANA.map((card) => ({
    id: `major-${card.rank}`,
    arcana: "major",
    suit: null,
    rankKey: String(card.rank),
    number: toCardNumber(card.rank),
    icon: "✦",
  }));
}

function buildMinorArcanaCards() {
  return SUITS.flatMap((suit) => {
    return MINOR_RANKS.map((rank, idx) => ({
      id: `minor-${suit.key}-${rank.key}`,
      arcana: "minor",
      suit: suit.key,
      rankKey: rank.key,
      number: idx < 10 ? String(idx + 1) : rank.key.toUpperCase(),
      icon: suit.icon,
    }));
  });
}

export const TAROT_DECK = [...buildMajorArcanaCards(), ...buildMinorArcanaCards()];

export const TAROT_CARD_BY_ID = TAROT_DECK.reduce((memo, card) => {
  memo[card.id] = card;
  return memo;
}, {});

export function getTarotLocale(localeRaw) {
  return String(localeRaw || "en").toLowerCase().startsWith("vi") ? "vi" : "en";
}
